export default __webpack_public_path__ + "static/media/grafema_nutrana_06.786429fc.jpg";